export default () => {
  const isEnabled_ = ref(false)
  function setEnabled(isEnabled: boolean) {
    isEnabled_.value = isEnabled
  }

  const { proxy } = useScriptGoogleTagManager()

  function track(event: Parameters<typeof proxy.dataLayer.push>[0]) {
    if (!isEnabled_) {
      return
    }
    return proxy.dataLayer.push(event)
  }

  return { setEnabled, track }
}
